import Newsletter from "../../components/Footer/components/Newsletter/Newsletter";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Hero from "../../components/Hero/Hero";
import { NextSeo } from "next-seo";
import Person from "./components/Person";

export default function () {
    return (
        <div>
            <Header />
            <NextSeo
                title="Dzobs.com Tim"
                description="Ekipa koja stoji iza dzobs.com portala."
                canonical="https://www.dzobs.com/open"
                openGraph={{
                    images: [
                        {
                            url: "https://www.dzobs.com/social.png",
                        },
                    ],
                }}
            />
            <Hero
                title="Upoznajte dzobsov tim"
                subtitle="Upoznajte ekipu koja stoji iza dzobs.com portala."
            />
            <article
                className="blog-post mt-16 mb-32 max-w-screen-xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 leading-7"
                role="text"
            >
                <Person
                    image="/slike/tim/goran.jpeg"
                    name="Goran Jakovljević"
                    description="Započeo dzobs platformu i okupio sjajan tim da dovrše priču. Voli pokretati projekte i odustajati na 90% završenog posla."
                    title="Founder"
                    fb="https://www.facebook.com/goran.jakovljevic/"
                    ln="https://www.linkedin.com/in/gjakovljevic/"
                />
                <Person
                    image="/slike/tim/petar.jpeg"
                    name="Petar Vuković"
                    description="Kune se u organizaciju i notion, vjerovatno svako veče baci koju notion molitvu. Programira kad mu je dosadno. Sve nas organizuje, vodi blog i analitiku."
                    title="CoFounder"
                    fb="https://www.facebook.com/perica.vukovic"
                    ln="https://www.linkedin.com/in/pvukovic/"
                />
                <Person
                    image="/slike/tim/nikola.jpeg"
                    name="Nikola Novaković"
                    description="Apple fanboy, iz nekog razloga još uvijek. Održava komunikaciju sa firmama i svu administraciju (fali jedan papir) na šta je tim jako zahvalan <3."
                    title="CoFounder"
                    fb="https://www.facebook.com/vronski86"
                    ln="https://www.linkedin.com/in/novakovicn/"
                />
                <Person
                    image="/slike/tim/vanja.jpeg"
                    name="Vanja Stjepanović"
                    description="Brzo kliknula kako developeri razmišljaju. Nije kilnula Gorana (još uvijek). Vodi sales ($$$) i društvene mreže dzobsa."
                    title="Manager of Business development"
                    fb="https://www.facebook.com/vanjastjepanovic13"
                    ln="https://www.linkedin.com/in/vanja-stjepanovi%C4%87-ba971925/"
                />

                <Person
                    image="/slike/tim/stefan.jpeg"
                    name="Stefan Kajkut"
                    description="Završio u hitnoj zbog prekovremenog rada (naravno ne u dzobsu), ali iz nekog razloga se i dalje bavi developmentom. Rješava back ali i frontend taskove na dzobsu."
                    title="Management/Backend dev"
                    fb="https://www.facebook.com/skajkut"
                    ln="https://www.linkedin.com/in/stefan-kajkut/"
                />

                <Person
                    image="/slike/tim/milan.jpeg"
                    name="Milan Blaz"
                    description="Nije završio u hitnoj zbog prekovremenog rada (opet, ne u dzobsu), vjerovatno nikad i neće jer ga boli patka za svime. Rješava front ali i backend taskove na dzobsu."
                    title="Management/Frontend dev"
                    fb="https://www.facebook.com/micko.sestic"
                    ln="https://www.linkedin.com/in/milan-blaz-2b687b171/"
                />

                <Person
                    image="/slike/tim/marko.jpeg"
                    name="Marko Ćebić"
                    description="Ovaj je pravi šaljivdžija. Budemo jednom objavili slack prepiske sa njim po kanalima. Vodi content i drži sve pod špagom. U slobodno vrijeme voli da se ne javlja na telefon."
                    title="Head of content"
                    fb="https://www.facebook.com/marko.cebic"
                    ln="https://www.linkedin.com/in/marko-cebic-84128922b/"
                />

                <Person
                    image="/slike/tim/danka.jpeg"
                    name="Danka Babić"
                    description="Kada ne prodaje igračke u Lunarisu, provjerava oglase i dodaje nove. Vjerovatno prije snimanja, provjeri isti 3 puta. Voli da ima skroz popunjen dan sa poslom...mladost, ludost."
                    title="Content & QA"
                    fb="https://www.facebook.com/danka.babic.77"
                />
            </article>
            <Newsletter bg="bg-gray-light" />
            <Footer />
        </div>
    );
}
